<template>
  <div class="number-increment">
    <span
      @mouseleave="clearTimer"
      @mouseup="clearTimer"
      @mousedown="setTimerDecrease"
      @click="$emit('decrease')"
    >
      <Icon class="left-icon cursor-pointer" :width="9" :height="9" color="#707070" icon="minus" />
    </span>
    <input :ref="inputRef" class="number" type="text" @input="handleInput" />
    <span
      @mouseleave="clearTimer"
      @mouseup="clearTimer"
      @mousedown="setTimerIncrease"
      @click="$emit('increase')"
    >
      <Icon class="right-icon cursor-pointer" :width="9" :height="9" color="#707070" icon="plus" />
    </span>
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  components: {
    Icon
  },
  props: {
    numberShown: {
      type: Number,
      required: true
    },
    inputKey: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      timerId: 0
    };
  },
  computed: {
    inputRef() {
      return `input-${this._uid}`;
    }
  },
  watch: {
    numberShown(newValue) {
      this.setInputValue(newValue);
    }
  },
  mounted() {
    this.setInputValue(this.numberShown);
  },
  methods: {
    increase() {
      this.$emit('increase');
    },
    setTimerIncrease() {
      this.timerId = setInterval(() => {
        this.increase();
      }, 200);
    },
    clearTimer() {
      clearInterval(this.timerId);
    },
    decrease() {
      this.$emit('decrease');
    },
    setTimerDecrease() {
      this.timerId = setInterval(() => {
        this.decrease();
      }, 200);
    },
    handleInput(e) {
      const newValue = e.target.value;
      const regExpNotNumber = /[^0-9]/g;
      const isNumberInvalid = regExpNotNumber.test(newValue);
      if (isNumberInvalid) {
        this.setInputValue(this.numberShown);
        return;
      }
      this.$emit('input', newValue);
    },
    setInputValue(newValue) {
      this.$refs[this.inputRef].value = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.number-increment {
  width: fit-content;
  border-radius: 1em;
  border: 2px solid #eeeeee;
  padding: 3px 8px;
  color: #707070;
  margin: 0 auto;
  position: relative;
  @include sm {
    min-width: 65px;
  }
  .number {
    color: $softPurple;
    border: none;
    padding: 0 8px;
    text-align: center;
    width: 4em;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &[type='number'] {
      -moz-appearance: textfield;
    }
  }

  .left-icon {
    position: absolute;
    left: 9px;
    top: 10px;
  }
  .right-icon {
    position: absolute;
    right: 9px;
    top: 10px;
  }
}
</style>
